import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import { useAuth } from '../lib/auth';
import { Logo } from '../components/Logo';
import { PaymentCardStep } from '../components/PaymentCardStep';

// Standalone preview of the onboarding card-on-file step. Requires sign-in
// (the Stripe SetupIntent is tied to the signed-in account). Runs the REAL
// flow against Stripe test mode — use card 4242 4242 4242 4242.
export function PaymentPreview() {
  const { fbUser, profile, demoMode } = useAuth();
  const [saved, setSaved] = useState(false);

  return (
    <div className="min-h-screen bg-sky-50/40">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-2xl items-center justify-between px-4 py-3">
          <Logo className="h-7" />
          <span className="rounded-full bg-amber-100 px-2.5 py-1 text-xs font-medium text-amber-800">
            Card preview — Stripe test mode
          </span>
        </div>
      </header>

      <main className="mx-auto max-w-2xl px-4 py-8">
        <h1 className="font-display text-2xl font-semibold text-navy-900">Payment method</h1>
        <p className="mt-1 text-sm text-ink-muted">
          The card-on-file step from onboarding. Use Stripe’s test card{' '}
          <strong>4242 4242 4242 4242</strong>, any future expiry, any CVC/ZIP.
        </p>

        {!fbUser ? (
          <div className="card mt-6 p-8 text-center">
            <p className="text-ink-muted">You need to be signed in to try this (the card saves to your account).</p>
            <Link to="/login" className="btn-primary mt-4 inline-block">
              Sign in first
            </Link>
            <p className="mt-3 text-xs text-ink-muted">Then come back to this link.</p>
          </div>
        ) : saved ? (
          <div className="card mt-6 p-8 text-center">
            <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-emerald-100">
              <Check className="text-emerald-700" size={24} />
            </div>
            <h2 className="font-display text-lg font-semibold text-navy-900">Card saved to Stripe</h2>
            <p className="mt-2 text-sm text-ink-muted">
              That’s the exact flow a pilot completes in onboarding. It’s now saved off-session for
              billing.
            </p>
          </div>
        ) : (
          <div className="mt-6">
            <PaymentCardStep
              demoMode={demoMode}
              savedCard={
                profile?.paymentMethodOnFile
                  ? { brand: profile.cardBrand, last4: profile.cardLast4 ?? '••••' }
                  : null
              }
              onSaved={() => setSaved(true)}
            />
          </div>
        )}
      </main>
    </div>
  );
}
